import { func, shape, string } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import { merchantExclusivityOptions } from '../../campaigns/constants';
import SingleSelect from '../../generic/SingleSelect';
import { campaignShape } from '../../prop-types';

function ChangeMerchantExclusivityForm({ value, onChange, campaign }) {
  return (
    <Col sm={4}>
      <FormGroup>
        <Label for="currentMerchantExclusivity">Current</Label>
        <SingleSelect
          value={campaign.merchantExclusivity}
          options={merchantExclusivityOptions}
          onChange={onChange}
          readOnly
          id="currentMerchantExclusivity"
          name="currentMerchantExclusivity"
        />
      </FormGroup>
      <FormGroup>
        <Label for="newMerchantExclusivity">New</Label>
        <SingleSelect
          value={value.merchantExclusivity}
          options={merchantExclusivityOptions}
          isOptionDisabled={option =>
            option.value === campaign.merchantExclusivity
          }
          id="newMerchantExclusivity"
          name="merchantExclusivity"
          onChange={onChange}
        />
      </FormGroup>
    </Col>
  );
}

ChangeMerchantExclusivityForm.propTypes = {
  campaign: campaignShape.isRequired,
  onChange: func.isRequired,
  value: shape({ merchantExclusivity: string.isRequired }).isRequired,
};

export default ChangeMerchantExclusivityForm;
